import { Nodo, Sector } from "../../mantenimiento-operaciones";
import { City } from "../../system-settings";
import { OLT } from "../olt";





export interface CajaPrimariaPagingRes {
  last_id: number;
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: CajaPrimaria[];
}



export interface CajaPrimaria {
    id_caja_primaria?:string;
    estado: boolean;
    codigo: string;
    numero_referencia: string;
    nombre: string;
    direccion: string;
    coordenadas: string;
    latitud: string;
    longitud: string;
    estado_caja_primaria: CajaPrimariaEstadoFisicoEnum;
    proyecto_cod: string;
    puertos?: any;
    es_soterrado: boolean;
    cantidad_puertos: number;
    potencia_maxima: string;
    potencia_minima: string;
    puerto: number;
    tarjeta: string;
    sector: string;
    ciudad: string;
    nodo: string;
    olt: string;
    bras: string;
    fecha_instalacion?: string;
    user_instalacion?: string;
    nombre_tecnico_instalacion?: string;
    area_responsable?: string;
    splitter?:string
}

export type CajaPrimariaExtended = Partial<CajaPrimaria> & {
    nodo_data?: Nodo;
    olt_data?: OLT;
    sector_data?: Sector;
    ciudad_data?: City;
}

export interface CajaPrimariaParams extends Partial<CajaPrimaria> {

}

export enum CajaPrimariaEstadoFisicoEnum {
  HABILITADO= "HABILITADO",
  NO_HABILITADO= "NO HABILITADO",
  PENDIENTE= "PENDIENTE"
}

export const OptionsCajaPrimariaEstadoFisico = [
  CajaPrimariaEstadoFisicoEnum.HABILITADO,
  CajaPrimariaEstadoFisicoEnum.NO_HABILITADO,
  CajaPrimariaEstadoFisicoEnum.PENDIENTE
]
